export default function CarouselNext() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
        <circle cx="20" cy="20" r="19.25" transform="matrix(-1 0 0 1 40.5 0)" strokeWidth="1.5"/>
        <path d="M18.5 14L24.5 20L18.5 26" strokeWidth="1.5"/>
    </svg>
  );
}
